// Sentry temporarily disabled while debugging Cloudflare Worker runtime.
//
// The Sentry packages (`@sentry/vue`, `@sentry/browser`, `@sentry/core`)
// pull `debug` in via several transitive paths and are a likely contributor
// to the `debug_1$3.default is not a function` interop crash on Workers.
// Keeping this file as a no-op plugin (instead of deleting it) so the file
// listing stays consistent and re-enabling is a one-line revert.
import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin(() => {
	// no-op
});

/*
import * as Sentry from "@sentry/vue";
import { defineNuxtPlugin, useRuntimeConfig } from "nuxt/app";

export default defineNuxtPlugin((nuxtApp) => {
	if (process.client) {
		const runtimeConfig = useRuntimeConfig();

		if (!runtimeConfig.public.sentry.dsn) {
			return;
		}

		if (process.env.ENV === "production") {
			Sentry.init({
				app: nuxtApp.vueApp,
				dsn: runtimeConfig.public.sentry.dsn,
				environment: runtimeConfig.public.sentry.environment,
				ignoreErrors: ["Page Not Found"]
			});
		}
	}
});
*/
